/**
 * API
 * !backend: Laravel
 */

import axios from "axios";

export default {
  get(request, success, danger) {
    axios
      .get(request.url, {
        headers: {
          Authorization: `Bearer ${request.token || ""}`,
        },
      })
      .then((res) => {
        success(res);
      })
      .catch((err) => {
        if (err.response) {
          danger(err.response);
        } else {
          console.error("Error en GET", err);
          danger(err);
        }
      });
  },

  post(request, success, danger) {
    axios
      .post(request.url, request.params, {
        headers: {
          Authorization: `Bearer ${request.token || ""}`,
        },
      })
      .then((res) => {
        success(res);
      })
      .catch((err) => {
        if (err.response) {
          danger(err.response);
        } else {
          console.error("Error en POST", err);
          danger(err);
        }
      });
  },
};